import { ObservableFromFetch } from "../ObservableFromFetch"
import ImplementationUserLabels from "./Model/ImplementationUserLabels"

export default function GetImplementationUserLabels() {
  return ObservableFromFetch<ImplementationUserLabels>("FFOrderClinicFileMaintenance/GetImplementationUserLabels")
}

export function SaveImplementationUserLabels(userLabels: ImplementationUserLabels) {
  const requestBody = JSON.stringify(userLabels)
  return ObservableFromFetch<ImplementationUserLabels>("FFOrderClinicFileMaintenance/SaveImplementationUserLabels", requestBody)
}
